import {
	AcceptanceStatus,
	DocumentStatus,
	TransactionState,
} from '@dealstack/shared/lib/generated';
import { EXPECTED_STATUS } from '@dealstack/shared/lib/common/business/kyc';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

export const REQUESTED_STATUS = 'REQUESTED' as const;
/** A pending KYC file whose nominated certifier has not signed yet. */
export const AWAITING_CERTIFIER_STATUS = 'AWAITING_CERTIFIER' as const;
export type KycDisplayStatus = AcceptanceStatus | typeof EXPECTED_STATUS;
export type KycFileDisplayStatus = KycDisplayStatus | typeof AWAITING_CERTIFIER_STATUS;

type AnyStatus =
	| AcceptanceStatus
	| DocumentStatus
	| TransactionState
	| typeof EXPECTED_STATUS
	| typeof AWAITING_CERTIFIER_STATUS;

export const getIconFromStatus = (status: AnyStatus): PredefinedIcons | undefined => {
	switch (status) {
		case EXPECTED_STATUS:
		case AWAITING_CERTIFIER_STATUS:
		case DocumentStatus.PENDING:
		case TransactionState.PENDING:
			return 'circle-progress';
		case AcceptanceStatus.PENDING:
		case DocumentStatus.NA:
			return 'circle-dot';
		case AcceptanceStatus.APPROVED:
		case DocumentStatus.COMPLETE:
		case DocumentStatus.COMPLETED_OUTSIDE_DEALSTACK:
		case TransactionState.COMPLETED:
			return 'circle-check';
		case AcceptanceStatus.REJECTED:
		case AcceptanceStatus.REREQUESTED:
		case DocumentStatus.INCOMPLETE:
		case TransactionState.INCOMPLETE:
			return 'circle-cross';
		default:
			return;
	}
};

export const getColorFromStatus = (status: AnyStatus): string => {
	switch (status) {
		case EXPECTED_STATUS:
		case DocumentStatus.PENDING:
		case TransactionState.PENDING:
			return 'orange.6';
		case AcceptanceStatus.PENDING:
		case DocumentStatus.NA:
			return 'dark.9';
		case AcceptanceStatus.APPROVED:
		case DocumentStatus.COMPLETE:
		case DocumentStatus.COMPLETED_OUTSIDE_DEALSTACK:
		case TransactionState.COMPLETED:
			return 'teal.8';
		case AcceptanceStatus.REJECTED:
		case AcceptanceStatus.REREQUESTED:
		case DocumentStatus.INCOMPLETE:
		case TransactionState.INCOMPLETE:
			return 'red.8';
		default:
			return 'dark.9';
	}
};

export const getKycStatusColor = (status: AnyStatus | typeof REQUESTED_STATUS): string => {
	switch (status) {
		case EXPECTED_STATUS:
		case REQUESTED_STATUS:
			return 'orange.6';
		case AcceptanceStatus.PENDING:
			return 'blue.6';
		case AWAITING_CERTIFIER_STATUS:
			return 'violet.6';
		case AcceptanceStatus.APPROVED:
			return 'teal.8';
		case AcceptanceStatus.REJECTED:
		case AcceptanceStatus.REREQUESTED:
			return 'red.6';
		default:
			return getColorFromStatus(status);
	}
};

export const resolveStatusBadgeColors = (color: string): { color: string; textColor: string } => ({
	color: color === 'dark.4' ? 'gray.4' : color,
	textColor: color,
});
